// extracted by mini-css-extract-plugin
module.exports = {"markButton":"TextFormat_markButton__rAAeL","active":"TextFormat_active__L7vJe"};